(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('selectUnit', SelectUnit)

    /** @ngInject */
    function SelectUnit($state, $rootScope, AuthenticationService, HelperService, PATHS, DATA_EVENTS) {
        function SelectUnitController() {
            const vm = this;

            vm.onChangeUnit = () => {
                const currentSelectedUnit = AuthenticationService.getSelectedUnit();

                if (vm.selectedUnit.Id && vm.selectedUnit.Id != currentSelectedUnit.Id) {
                    AuthenticationService
                        .setUnit(vm.selectedUnit.Id)
                        .then(response => {
                            $rootScope.$broadcast(DATA_EVENTS.SELECTED_UNIT_CHANGE);

                            AuthenticationService.configureUserPermissions($state.current);

                            if (response.error)
                                HelperService.handleStateChangeError(response);
                        }, error => {
                            console.log('error: ', error);
                            $rootScope.$broadcast(DATA_EVENTS.SELECTED_UNIT_CHANGE);

                            AuthenticationService.configureUserPermissions($state.current);

                            HelperService.handleStateChangeError(error);
                        })
                }
            }

            vm.toggleSelectUnit = () => {
                $rootScope.showSelectUnit = !$rootScope.showSelectUnit;
            }

            init();

            function init() {
                const authSelectedUnit = AuthenticationService.getSelectedUnit();

                vm.units = AuthenticationService.getUnits();

                let foundUnit = vm.units.find(unit => (unit.Id == authSelectedUnit.Id));

                if (foundUnit)
                    vm.selectedUnit = foundUnit;
            }
        }

        return {
            bindToController: true,
            controller: SelectUnitController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/select-unit/select-unit.html`,
            scope: {
                show: '='
            }
        }
    }
}());